export interface ExternalProviderHour {
  day: string;
  hour: string;
}

export interface ExternalProviderLanguage {
  language: string;
  description?: string;
  services?: string[];
  restrictions?: string[];
  hours?: ExternalProviderHour[];
}

export interface ExternalProviderLocation {
  name?: string;
  addressLine1?: string;
  addressLine2?: string;
  city?: string;
  state?: string;
  zip?: string;
  restrictions?: string[];
}

export interface ExternalProviderService {
  name?: string;
  description?: string;
  rewardsType?: string;
  parcaPoints?: string;
}

export interface ExternalProvider {
  _id: string;
  id: string;
  accountId: string;
  categoryId: string;
  name: string;
  description: string;
  email?: string;
  website?: string;
  phoneNumber?: string;
  allowPP?: string;
  status?: string;
  locations?: ExternalProviderLocation;
  languages: ExternalProviderLanguage[];
  services?: ExternalProviderService;
  isDeleted: boolean;
  createdAt: string;
  updatedAt?: string;
  createdBy: string;
  updatedBy?: string;
}

export type ExternalProviderPayload = {
  categoryId: string;
  name: string;
  description: string;
  languages: ExternalProviderLanguage[];
  email?: string;
  website?: string;
  phoneNumber?: string;
  allowPP?: string;
  status?: string;
  locations?: ExternalProviderLocation;
  services?: ExternalProviderService;
  createdBy?: string;
  updatedBy?: string;
};

export const WEEK_DAYS: string[] = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];
